import { TylerIconRegistry } from './icon-registry';
import { ICON_CONSTANTS } from './icon-constants';
import { createSvgFromString } from '../core/svg-utils';
var _activeIconRequests = new Map();
/** Determines if the provided SVG icon content is valid */
export function sanitizeSvgContent(svgContent, customViewBox, usePartAttrs) {
    if (usePartAttrs === void 0) { usePartAttrs = true; }
    if (!svgContent || !svgContent.includes('svg')) {
        return '';
    }
    if (!customViewBox) {
        customViewBox = "0 0 " + ICON_CONSTANTS.numbers.DEFAULT_WIDTH + " " + ICON_CONSTANTS.numbers.DEFAULT_HEIGHT;
    }
    var svgElement = createSvgFromString(svgContent, customViewBox);
    if (usePartAttrs && svgElement) {
        svgElement.setAttribute('part', 'svg');
        svgElement.querySelectorAll('path').forEach(function (node) {
            node.setAttribute('part', node.tagName.toLowerCase());
        });
    }
    return svgElement ? svgElement.outerHTML : '';
}
export function getCachedIcon(key) {
    return TylerIconRegistry.get(key);
}
export function fetchIconContent(url, name) {
    // Check if we already have an active request for this URL
    var request = _activeIconRequests.get(url);
    if (!request) {
        if (typeof fetch !== 'undefined' && typeof document !== 'undefined') {
            // we don't already have a request
            request = fetch(url).then(function (response) {
                if (response.ok) {
                    return response.text().then(function (data) {
                        data = data || '';
                        TylerIconRegistry.define({ name: name, data: data });
                        _activeIconRequests.delete(url);
                        return data;
                    });
                }
                TylerIconRegistry.define({ name: name, data: '' });
                return '';
            });
            // Cache this request in case of duplicate requests
            _activeIconRequests.set(url, request);
        }
        else {
            // set to empty for ssr scenarios and resolve promise
            TylerIconRegistry.define({ name: name, data: '' });
            return Promise.resolve('');
        }
    }
    return request || Promise.resolve('');
}
export function sanitizeExternalType(type) {
    var isValidType = ['standard', 'extended', 'custom'].includes(type);
    return isValidType ? type : '';
}
